import request from '@/request/axios'

export function get(url, data, header = {}) {
    return base(url, 'get', data,header)
}
export function post(url, data) {
    let qs = require('qs')
    return base(url, 'post', qs.stringify(data))
}
// 文件上传方法
export function upload(url, data) {
    let header = { 'Content-Type': 'multipart/form-data' }
    return base(url, 'post', data, header)
}
function base(url, method = 'post', data = {}, header = {}) {
    if (header['Content-Type'] == undefined) {
        header['Content-Type'] = 'application/x-www-form-urlencoded'
    }
    let config = {
        url: url,
        method: method,
        header: header,
    }
    if (method == 'post') {
        config.data = data
    } else {
        config.params = data
    }
    return request(config)
}
